import { parse } from '../../util/urlHelpers';

import axios from 'axios';
import { apiBaseUrl } from '../../util/api';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { fetchCurrentUser, fetchCurrentWorkerUserExtraDetails } from '../../ducks/user.duck';

const RESULT_PAGE_SIZE = 18;

// ================ Action types ================ //

export const FETCH_ALL_WORKERS_REQUEST = 'app/SuperAdminDashboard/FETCH_ALL_WORKERS_REQUEST';
export const FETCH_ALL_WORKERS_SUCCESS = 'app/SuperAdminDashboard/FETCH_ALL_WORKERS_SUCCESS';
export const FETCH_ALL_WORKERS_ERROR = 'app/SuperAdminDashboard/FETCH_ALL_WORKERS_ERROR';

export const FETCH_UNVERIFIED_WORKERS_REQUEST =
  'app/SuperAdminDashboard/FETCH_UNVERIFIED_WORKERS_REQUEST';
export const FETCH_UNVERIFIED_WORKERS_SUCCESS =
  'app/SuperAdminDashboard/FETCH_UNVERIFIED_WORKERS_SUCCESS';
export const FETCH_UNVERIFIED_WORKERS_ERROR =
  'app/SuperAdminDashboard/FETCH_UNVERIFIED_WORKERS_ERROR';

export const FETCH_FILTERED_WORKERS_REQUEST =
  'app/SuperAdminDashboard/FETCH_FILTERED_WORKERS_REQUEST';
export const FETCH_FILTERED_WORKERS_SUCCESS =
  'app/SuperAdminDashboard/FETCH_FILTERED_WORKERS_SUCCESS';
export const FETCH_FILTERED_WORKERS_ERROR = 'app/SuperAdminDashboard/FETCH_FILTERED_WORKERS_ERROR';
export const FETCH_ALL_BLOCKED_WORKERS_REQUEST =
  'app/BusinessDashboard/FETCH_ALL_BLOCKED_WORKERS_REQUEST';
export const FETCH_ALL_BLOCKED_WORKERS_SUCCESS =
  'app/BusinessDashboard/FETCH_ALL_BLOCKED_WORKERS_SUCCES';
export const FETCH_ALL_BLOCKED_WORKERS_ERROR =
  'app/BusinessDashboard/FETCH_ALL_BLOCKED_WORKERS_ERROR';
export const SEARCH_FILTERED_WORKER_REQUEST =
  'app/BusinessDashboard/SEARCH_FILTERED_WORKER_REQUEST';
export const SEARCH_FILTERED_WORKER_SUCCESS = 'app/BusinessDashboard/SEARCH_FILTERED_WORKER_SUCCES';
export const SEARCH_FILTERED_WORKER_ERROR = 'app/BusinessDashboard/SEARCH_FILTERED_WORKER_ERROR';

// ================ Reducer ================ //

const initialState = {
  fetchInProgress: false,
  fetchAllWorkersError: null,
  pagination: null,
  currentPageWorkers: [],
  currentPageUnverifiedWorkers: [],
  filteredWorkers: [],
  blockedWorkersId: [],
};

export default function SuperAdminDashboardPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  // console.log(333, payload);
  switch (type) {
    case FETCH_ALL_WORKERS_REQUEST:
      return {
        ...state,
        fetchInProgress: true,
        fetchAllWorkersError: null,
        currentPageWorkers: [],
        blockedWorkersId: [],
      };
    case FETCH_ALL_WORKERS_SUCCESS: {
      // console.log(988, payload);
      return {
        ...state,
        fetchInProgress: false,
        currentPageWorkers: payload.data.data,
        pagination: payload.data.meta,
      };
    }
    case FETCH_ALL_WORKERS_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchInProgress: false, fetchAllWorkersError: payload };
    case FETCH_UNVERIFIED_WORKERS_REQUEST:
      return {
        ...state,
        fetchInProgress: true,
        fetchUnverifiedWorkersError: null,
        currentPageUnverifiedWorkers: [],
      };
    case FETCH_UNVERIFIED_WORKERS_SUCCESS: {
      return {
        ...state,
        fetchInProgress: false,
        currentPageUnverifiedWorkers: payload.data,

        pagination: payload,
      };
    }
    case FETCH_UNVERIFIED_WORKERS_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchInProgress: false, fetchUnverifiedWorkersError: payload };

    case FETCH_FILTERED_WORKERS_REQUEST:
      return {
        ...state,
        fetchInProgress: true,
      };
    case FETCH_FILTERED_WORKERS_SUCCESS: {
      return {
        ...state,
        fetchInProgress: false,
        // filteredWorkers: payload?.data?.data,
        pagination: payload?.data?.meta,
        currentPageWorkers: payload?.data?.data,
      };
    }
    case FETCH_FILTERED_WORKERS_ERROR:
      console.error(payload); // eslint-disable-line
      return {
        ...state,
        fetchInProgress: false,
        filteredWorkers: [],
        pagination: null,
        fetchAllWorkersError: payload,
      };
    case FETCH_ALL_BLOCKED_WORKERS_REQUEST:
      return {
        ...state,
        fetchInProgress: true,
        fetchAllWorkersError: null,
        currentPageWorkers: [],
        blockedWorkersId: [],
      };
    case FETCH_ALL_BLOCKED_WORKERS_SUCCESS: {
      // console.log(56000, payload, type);
      return {
        ...state,
        fetchInProgress: false,
        currentPageWorkers: [],
        blockedWorkersId: [...payload],
        // pagination: payload.data.meta,
      };
    }
    case FETCH_ALL_BLOCKED_WORKERS_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchInProgress: false, fetchAllWorkersError: payload };
    case SEARCH_FILTERED_WORKER_REQUEST:
      return {
        ...state,
        fetchInProgress: true,
        currentPageWorkers: [],
      };
    case SEARCH_FILTERED_WORKER_SUCCESS: {
      return {
        ...state,
        fetchInProgress: false,
        currentPageWorkers: payload.data.data,
        pagination: payload.data.meta,
      };
    }
    case SEARCH_FILTERED_WORKER_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchInProgress: false, fetchAllWorkersError: payload };
    default:
      return state;
  }
}
// ================ Action creators ================ //

const fetchAllWorkersRequest = () => ({ type: FETCH_ALL_WORKERS_REQUEST });
const fetchAllWorkersSuccess = response => ({
  type: FETCH_ALL_WORKERS_SUCCESS,
  payload: response,
});
const fetchAllWorkersError = e => ({
  type: FETCH_ALL_WORKERS_ERROR,
  error: true,
  payload: e,
});
const fetchAllUnverifiedWorkersRequest = () => ({ type: FETCH_UNVERIFIED_WORKERS_REQUEST });
const fetchAllUnverifiedWorkersSuccess = response => ({
  type: FETCH_UNVERIFIED_WORKERS_SUCCESS,
  payload: response,
});
const fetchAllUnverifiedWorkersError = e => ({
  type: FETCH_UNVERIFIED_WORKERS_ERROR,
  error: true,
  payload: e,
});
const filteredWorkersRequest = () => ({ type: FETCH_FILTERED_WORKERS_REQUEST });
const filteredWorkersSuccess = response => ({
  type: FETCH_FILTERED_WORKERS_SUCCESS,
  payload: response,
});
const filteredWorkersError = e => ({
  type: FETCH_FILTERED_WORKERS_ERROR,
  error: true,
  payload: e,
});

const searchFilteredWorkerRequest = () => ({ type: SEARCH_FILTERED_WORKER_REQUEST });
const searchFilteredWorkerSuccess = response => ({
  type: SEARCH_FILTERED_WORKER_SUCCESS,
  payload: response,
});
const searchFilteredWorkerError = e => ({
  type: SEARCH_FILTERED_WORKER_ERROR,
  error: true,
  payload: e,
});
const fetchAllBlockedWorkersRequest = () => ({ type: FETCH_ALL_BLOCKED_WORKERS_REQUEST });
const fetchAllBlockedWorkersSuccess = response => ({
  type: FETCH_ALL_BLOCKED_WORKERS_SUCCESS,
  payload: response,
});
const fetchAllBlockedWorkersError = e => ({
  type: FETCH_ALL_BLOCKED_WORKERS_ERROR,
  error: true,
  payload: e,
});
// ================ Thunks ================ //

export const fetchAllWorkers = param => (dispatch, getState, sdk) => {
  const { page = 1, tab } = param;
  // console.log(525, tab);

  dispatch(fetchAllWorkersRequest());
  const url =
    tab === 'AllWorkersTab'
      ? `${apiBaseUrl()}/api/user/admin/allworkers?page=${page}`
      : tab === 'ApprovalPendingTab'
      ? `${apiBaseUrl()}/api/user/admin/unverifiedWorkers?page=${page}`
      : tab === 'VerificationPendingTab'
      ? `${apiBaseUrl()}/api/user/admin/verificationPendingWorker?page=${page}`
      : '';
  return axios
    .get(url, {
      withCredentials: true,
      // per_Page: RESULT_PAGE_SIZE,
    })
    .then(response => {
      let sucessResp;
      if (tab === 'AllWorkersTab' || tab === 'VerificationPendingTab') {
        sucessResp = response;
      } else {
        const includedArray = response?.data?.filter(f => f.included !== undefined);
        const newarray = [].concat(...includedArray.map(item => item.included));
        sucessResp = {
          data: {
            data: response?.data?.map(d => d?.data),
            included: newarray,
            meta: {},
          },
          status: 200,
          statusText: 'OK',
        };
      }
      // const includedArray = response?.data?.filter(f => f.included !== undefined);
      // const newarray = [].concat(...includedArray.map(item => item.included));
      // const sucessResp =
      //   tab === 'AllWorkersTab'
      //     ? response
      //     : {
      //         data: {
      //           data: response?.data?.map(d => d?.data),
      //           included: newarray,
      //           meta: {},
      //         },
      //         status: 200,
      //         statusText: 'OK',
      //       };
      // console.log(777, sucessResp);
      // if (tab === 'AllWorkersTab') {
      //   dispatch(addMarketplaceEntities(sucessResp));

      //   dispatch(fetchAllWorkersSuccess(sucessResp));
      // } else {
      dispatch(addMarketplaceEntities(sucessResp));

      dispatch(fetchAllWorkersSuccess(sucessResp));
    })
    .catch(error => {
      dispatch(fetchAllWorkersError(error));
    });
};

export const fetchUnVerifiedWorkers = param => (dispatch, getState, sdk) => {
  const { page = 1 } = param;
  dispatch(fetchAllUnverifiedWorkersRequest());

  return (
    axios
      .get(`${apiBaseUrl()}/api/user/admin/unverifiedWorkers?page=${page}`, {
        withCredentials: true,
        // per_Page: RESULT_PAGE_SIZE,
      })
      .then(response => {
        // console.log(response, 151);
        dispatch(fetchAllUnverifiedWorkersSuccess(response));
      })
      // .then(response => {
      //   console.log(111, response.data);
      //   const unverifiedWorkersData = response.data.map(wData => {
      //     // console.log(878, wData);
      //     return axios
      //       .get(`${apiBaseUrl()}/api/user/admin/staffData/?userId=${wData.userId} `, {
      //         withCredentials: true,
      //         // per_Page: RESULT_PAGE_SIZE,
      //       })
      //       .catch(error => {
      //         console.log(error);
      //       });
      //   });
      //   return Promise.all(unverifiedWorkersData).then(resp => {
      //     // const unverifiedWorkersData = resp.find(data => data);
      //     const unverifiedWorkersData = resp.filter(data => data).map(d => d.data);
      //     console.log(959, unverifiedWorkersData);
      //     dispatch(fetchAllUnverifiedWorkersSuccess(unverifiedWorkersData));
      //   });

      //   // dispatch(fetchAllUnverifiedWorkersSuccess(response));
      // })
      .catch(error => {
        // console.log(222, error);

        dispatch(fetchAllUnverifiedWorkersError(error));
      })
  );
};
export const filterWorker = params => (dispatch, getState, sdk) => {
  dispatch(fetchAllWorkersRequest());
  const { filter, page = 1, tab } = params;
  console.log(2233, params);
  if (tab === 'BlockedTab') {
    return axios
      .post(
        `${apiBaseUrl()}/api/user/getBlockedUsersBySearch`,
        {
          params,
        },
        { withCredentials: true }
      )
      .then(response => {
        const userIds = response?.data?.map(m => m?.blockedWorkerId);
        const data = Promise.all(
          userIds.map(m =>
            sdk.users.show(
              {
                id: m,
                include: ['profileImage'],
                'fields.image': [
                  'variants.default',
                  'variants.square-small',
                  'variants.square-small2x',
                ],
              },
              { expand: true }
            )
          )
        );

        data.then(res => {
          const blockedWorkersId = res.map(m => m.data.data.id);

          // console.log(56788, blockedWorkersId);

          const apiResp = {
            status: 200,
            statusText: '',
            data: {
              data: res.map(m => m.data.data),
              included: res.reduce((pre, curnt) => {
                pre.push(...(curnt.data.included || []));
                return pre;
              }, []),
            },
          };
          apiResp?.data?.data.map(m => {
            dispatch(fetchCurrentWorkerUserExtraDetails(m?.id?.uuid)).then(res => {
              Object.assign(m?.attributes?.profile?.publicData, res);
            });
          });
          dispatch(addMarketplaceEntities(apiResp));
          dispatch(fetchAllBlockedWorkersSuccess(blockedWorkersId));
        });
      });
  } else {
    return axios
      .post(`${apiBaseUrl()}/api/categorySearch`, params)
      .then(res => {
        const sucessResp = filter ? res.data : res;
        sucessResp.data.data.map(m => {
          return dispatch(fetchCurrentWorkerUserExtraDetails(m?.id?.uuid)).then(res => {
            Object.assign(m?.attributes?.profile?.publicData, res);
          });
        });
        dispatch(addMarketplaceEntities(sucessResp));
        return dispatch(filteredWorkersSuccess(sucessResp));
      })
      .catch(error => {
        dispatch(filteredWorkersError(error));
      });
  }

  // setSearchedUser(res?.data?.data?.data);
};
export const filterSearch = params => (dispatch, getState, sdk) => {
  // console.log(2300, params);
  const { searchItem, search, page = 1 } = params;

  dispatch(searchFilteredWorkerRequest());
  // return axios
  //   .post(`${apiBaseUrl()}/api/nameSearch`, { searchName })
  //   .then(res => {
  //     console.log(123, res);
  //     const success = { data: { ...res } };
  //     const SearchedWorker = success?.data?.data?.filter(
  //       f => !f?.attributes?.profile?.publicData?.isProvider
  //     );
  //     const FormattedSearchedWorkers = { data: { data: SearchedWorker } };
  //     // console.log(555,success, {data:{data:SearchedWorker}});
  //     // setSearchedUser(res?.data);
  //     dispatch(filteredWorkersSuccess(FormattedSearchedWorkers));
  //   })
  let paginationDetails;
  return axios
    .post(`${apiBaseUrl()}/api/user/findByIdOrName`, { searchItem, page, isProvider: false })
    .then(res => {
      paginationDetails = {
        page: res?.data?.page,
        pageSize: res?.data?.pageSize,
        totalPages: res?.data?.totalPages,
        totalCount: res?.data?.totalCount,
      };
      const ids = res?.data?.data?.map(m => m.StUserId);
      return Promise.all(
        ids.map(m =>
          sdk.users.show(
            {
              id: m,
              include: ['profileImage'],
              'fields.image': [
                'variants.default',
                'variants.square-small',
                'variants.square-small2x',
              ],
              // perPage: 10,
              // page,
            },
            { expand: true }
          )
        )
      )
        .then(res => {
          const result = res.map(m => {
            dispatch(fetchCurrentWorkerUserExtraDetails(m?.data?.data?.id?.uuid)).then(res => {
              Object.assign(m?.data?.data?.attributes?.profile?.publicData, res);
            });
            dispatch(addMarketplaceEntities(m));
            return m.data;
          });
          const data = result.map(m => m.data);
          return data;
        })
        .then(res => {
          const userdata = {
            data: { data: res, meta: paginationDetails },
          };
          // console.log(123, userdata);
          dispatch(searchFilteredWorkerSuccess(userdata));
        });
    })
    .catch(err => {
      // console.log(222, err);
      dispatch(searchFilteredWorkerError(err));
    });
};
export const fetchBlockedUser = param => async (dispatch, getState, sdk) => {
  // const { page = 1, id } = param;
  // console.log(789, id);
  dispatch(fetchAllBlockedWorkersRequest());
  await dispatch(fetchCurrentUser());
  const fetchedcurrentUser = getState().user.currentUser;
  //this id have to be change with the blocked user id
  const blockerid = fetchedcurrentUser?.attributes?.profile?.protectedData?.favourites || [];
  // console.log(1212, param);

  return axios
    .post(
      `${apiBaseUrl()}/api/user/getBlockedUsers`,
      {
        blockerid: null,
      },
      { withCredentials: true }
    )
    .then(response => {
      const userIds = response?.data?.map(m => m?.blockedWorkerId);
      const data = Promise.all(
        userIds.map(m =>
          sdk.users.show(
            {
              id: m,
              include: ['profileImage'],
              'fields.image': [
                'variants.default',
                'variants.square-small',
                'variants.square-small2x',
              ],
            },
            { expand: true }
          )
        )
      );

      data.then(res => {
        const blockedWorkersId = res.map(m => m.data.data.id);

        // console.log(56788, blockedWorkersId);

        const apiResp = {
          status: 200,
          statusText: '',
          data: {
            data: res.map(m => m.data.data),
            included: res.reduce((pre, curnt) => {
              pre.push(...(curnt.data.included || []));
              return pre;
            }, []),
          },
        };
        apiResp?.data?.data.map(m => {
          dispatch(fetchCurrentWorkerUserExtraDetails(m?.id?.uuid)).then(res => {
            Object.assign(m?.attributes?.profile?.publicData, res);
          });
        });
        dispatch(addMarketplaceEntities(apiResp));
        dispatch(fetchAllBlockedWorkersSuccess(blockedWorkersId));
      });
    })
    .catch(error => {
      dispatch(fetchAllBlockedWorkersError(error));
    });
};

export const loadData = (params, search) => (dispatch, getState, sdk) => {
  const queryParams = parse(search);
  const tab = queryParams.tab || 'AllWorkersTab';
  const slug = params.slug;
  const { page = 1 } = queryParams;
  const onlyFilterValues = {
    allWorkers: 'AllWorkersTab',
    approvalPending: 'ApprovalPendingTab',
  };

  const onlyFilter = onlyFilterValues[tab];
  //   if (!onlyFilter) {
  //     return Promise.reject(new Error(`Invalid tab for SuperAdminDashboard: ${tab}`));
  //   }
  // if (queryParams.filter) {
  //   return dispatch(filterWorker(queryParams));
  // }
  // if (tab === 'AllWorkersTab') {
  //   return dispatch(fetchAllWorkers({ page, tab }));
  // }
  // if (tab === 'ApprovalPendingTab') {
  //   return dispatch(fetchUnVerifiedWorkers({ page }));
  // }
  if (queryParams.filter) {
    return dispatch(filterWorker(queryParams));
  }
  // else if (queryParams.search) {
  //   return dispatch(filterSearch(queryParams));
  // }
  else if (tab === 'BlockedTab') {
    //  return dispatch(fetchPendingApproval({ page }));
    return dispatch(fetchBlockedUser());
  }
  return dispatch(fetchAllWorkers({ page, tab, filter: !!queryParams.filter }));

  //   dispatch(fetchAllWorkers());
  //   return dispatch(fetchAllWorkers(queryPage));
};
